import { useMessageToast } from '../../shared/hooks/useMessageToast';
import { useBranchInitialization } from '../hooks/useBranchInitialization';
import primitives from '../../../styles/primitives.module.css';
import bootstrapStyles from '../../auth/components/BootstrapForm.module.css';

export const BranchInitializationForm = ({ token, t, onComplete }) => {
  const {
    name,
    errorMessage,
    noticeMessage,
    isSubmitting,
    handleNameChange,
    handleSubmit,
  } = useBranchInitialization({ token, t, onComplete });

  useMessageToast(errorMessage, 'error');
  useMessageToast(noticeMessage, 'success');

  return (
    <section className={bootstrapStyles.container}>
      <div className={bootstrapStyles.header}>
        <h2>{t('branchInitTitle')}</h2>
        <p>{t('branchInitSubtitle')}</p>
      </div>

      <form className={`${primitives.form} ${bootstrapStyles.formGrid}`} onSubmit={handleSubmit}>
        <label className={`${primitives.field} ${bootstrapStyles.spanFull}`}>
          {t('branchInitNameLabel')}
          <input
            type="text"
            name="name"
            autoComplete="organization"
            value={name}
            onChange={handleNameChange}
            placeholder={t('branchInitNamePlaceholder')}
            required
            maxLength={200}
          />
        </label>

        <div className={bootstrapStyles.actionsRow}>
          <button className={primitives.primaryButton} type="submit" disabled={isSubmitting}>
            {isSubmitting ? t('branchInitCreating') : t('branchInitCreate')}
          </button>
        </div>
      </form>
    </section>
  );
};
